import rootSortConfig from './roots-sort.config'

export default [
  ...rootSortConfig,
  {
    title: 'Текст кнопки (А-Я)',
    field: 'btn_text.asc',
    options: {
      by: 'btn_text',
      order: 'asc'
    }
  },
  {
    title: 'Текст кнопки (Я-А)',
    field: 'btn_text.desc',
    options: {
      by: 'btn_text',
      order: 'desc'
    }
  },
]